import { BrowserModule, Title } from '@angular/platform-browser';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing.module';
import { AppComponent } from './app.component';
// Shared Modules
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { ObserveVisibilityDirective } from './shared/directives/observe-visibility.directive';
import {provideHttpClient} from "@angular/common/http";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import { CoreModule as AbsCodeModule } from 'abs-ngx-library/src/lib/core';

@NgModule({
  declarations: [
    AppComponent,
    ObserveVisibilityDirective
  ],
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    AbsCodeModule.forRoot({ programType: 'weeklyAd', appName: 'weeklyAd' })
  ],
  exports: [],
  providers: [provideHttpClient(),Title],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
